<template>
  <div>
    <DataTable
      :value="reminderTypes"
      :paginator="true"
      dataKey="contactId"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedRerminderTypes"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} reminderTypes"
    >
      <template #empty> No reminder types found. </template>
      <template #loading> Loading reminder types data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="reminderTypeCode"
        header="Code"
        headerStyle="width: 5em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.reminderTypeCode }}
          </div>
        </template>
      </Column>
      <Column
        field="reminderTypeName"
        header="Name"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.reminderTypeName }}
          </div>
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-info" 
              class="p-button-success p-mb-2"
              @click="editReminderType(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <SettingDeleteConfirm
      :visible.sync="displayDeleteConfirm"
      :row="rowToDelete"
      list="reminderTypes"
      :label="rowToDelete ? String(rowToDelete.reminderTypeName || '') : ''"
      what="reminder type"
      @deleted="row => $emit('deleted', row)"
    />
  </div>
</template>

<script>
import PermissionMixin from '../../PermissionMixin.vue'
import SettingDeleteConfirm from '../SettingDeleteConfirm.vue'
export default {
  mixins: [PermissionMixin],
  components: { SettingDeleteConfirm },
  props: [
    'reminderTypes',
    'loading'
  ],
  data: () => ({
    rowToDelete: null,
    displayDeleteConfirm: false,
    selectedRerminderTypes: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    getButtons(data) {
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteRerminderType(data)
            }
          }
        )
      }
      return buttons
    },
    // RT1: ask, then delete (SettingDeleteConfirm); it used to do nothing
    deleteRerminderType(row) {
      this.rowToDelete = row
      this.displayDeleteConfirm = true
    },
    editReminderType(reminderType) {
      this.$emit('edit-reminder-type', reminderType)
    }
  }
}
</script>

<style>

</style>